import { put, takeLatest } from 'redux-saga/effects';
import {
  ANDROID_APP_DETAILS,
  ANDROID_APP_DETAILS_RECOMMEND,
  GROUNP_CONTENT_53,
  APP_ADETAILS_70,
  APP_DETAILS_GIFT_70,
  APP_DETAILS_GIFT_RECEIVE_70,
} from '../config';
import {
  ANDROID_APP_DETAILS_REQUEST,
  ANDROID_APP_DETAILS_SUCCESS,
  ANDROID_APP_RECOMMEND_REQUEST,
  ANDROID_APP_RECOMMEND_SUCCESS,
  ANDROID_APP_GROUP_SUCCESS,
  ANDROID_APP_GROUP_REQUEST,
  ANDROID_APP_GIFT_REQUEST,
  ANDROID_APP_GIFT_SUCCESS,
  ANDROID_APP_GIFT_RECEIVE_REQUEST,
  ANDROID_APP_GIFT_RECEIVE_SUCCESS,
} from '../constants/adetail';
import { createAxios } from '../utils/utils';
import React from 'react';
import { message } from 'antd';
import success from '../static/msg-success.svg';
import fail from '../static/msg-fail.svg';

/**
 * 单个应用详情
 */
function* fetchAAppDetails({ pn = '', vc = 0, bizInfo = {} }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_ADETAILS_70, {
      params: { pn, vc, bizInfo: bizInfo || {} },
    });

    if (res.data.status === 0) {
      yield put({
        type: ANDROID_APP_DETAILS_SUCCESS,
        payload: { ...res.data.data, paramPN: pn, loading: false },
      });
    } else {
      yield put({
        type: ANDROID_APP_DETAILS_SUCCESS,
        payload: { ...res.data, paramPN: pn, loading: false },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 安卓详情推荐
 */
function* fetchAAppRecommend({ pn = '', vc = 0, classid = '' }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_APP_DETAILS_RECOMMEND, {
      params: { pn, vc, classid },
    });
    if (res.data.status === 0) {
      yield put({
        type: ANDROID_APP_RECOMMEND_SUCCESS,
        payload: { ...res.data.data, pn },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchAAppDetails() {
  yield takeLatest(ANDROID_APP_DETAILS_REQUEST, fetchAAppDetails);
}
export function* watchAAppRecommend() {
  yield takeLatest(ANDROID_APP_RECOMMEND_REQUEST, fetchAAppRecommend);
}

/**
 * 其他推荐group
 */
function* fetchGroupContent(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GROUNP_CONTENT_53, {
      params: {
        pageType: params.pageType,
        ztType: params.ztType,
      },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: ANDROID_APP_GROUP_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          ...params,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchAGroupContent() {
  yield takeLatest(ANDROID_APP_GROUP_REQUEST, fetchGroupContent);
}

/**
 * 获取礼包list
 */
function* fetchADetailGiftList({ softInfo, androidType }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_DETAILS_GIFT_70, {
      params: { softInfo, androidType },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: ANDROID_APP_GIFT_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          softInfo,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchADetailGiftList() {
  yield takeLatest(ANDROID_APP_GIFT_REQUEST, fetchADetailGiftList);
}

/**
 * 领取单个礼包
 */
function* fetchAReceiveGift(params) {
  try {
    yield put({
      type: ANDROID_APP_GIFT_RECEIVE_SUCCESS,
      payload: {
        loading: true,
        ...params,
      },
    });
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_DETAILS_GIFT_RECEIVE_70, {
      params,
    });

    if (res.data) {
      if (res.data.status === 0) {
        message.success({
          content: res.data.message,
          className: 'ant-message-notice-center',
          icon: <img className="ant-message-custom-img" src={success} alt="fail" />,
        });
      } else {
        message.error({
          content: res.data.message,
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      }
    }

    if (res.data) {
      yield put({
        type: ANDROID_APP_GIFT_RECEIVE_SUCCESS,
        payload: {
          loading: false,
          data: res.data,
          ...params,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchAReceiveGift() {
  yield takeLatest(ANDROID_APP_GIFT_RECEIVE_REQUEST, fetchAReceiveGift);
}
